import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { PaginationModule } from '../layout/pagination/pagination.module';
import { ModalUserComponent } from './modals/modal-user/modal-user.component';
import { UploadResultComponent } from './modals/upload-result/upload-result.component';
import { UsersComponent } from './users.component';

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    FormsModule,
    NgxCsvParserModule,
    UsersComponent,
    ModalUserComponent,
    UploadResultComponent,
  ],
  exports: [UsersComponent],
})
export class UsersModule {}
